import {mapState} from "vuex";

export default {
    computed: {
        ...mapState(['categories']),
        categoryOptions: function () {
            let opts = []
            for (let i = 0; i < this.categories.length; i++) {
                opts.push(
                    {id: this.categories[i].id, text: this.categories[i].name}
                )
            }
            return opts
        },
        subcategoryOptions: function () {
            let opts = [{id: '', text: '---'}]
            for (let i = 0; i < this.categories.length; i++) {
                if (this.categories[i].id == this.activity.category) {
                    for (let j = 0; j < this.categories[i].subcategories.length; j++) {
                        opts.push({
                            id: this.categories[i].subcategories[j].id,
                            text: this.categories[i].subcategories[j].name
                        })
                    }
                }
            }
            return opts
        },
    }
}